import { createRoutine } from 'redux-saga-routines';
import {
  GET_STORED_REGISTRATIONS,
  CREATE_REGISTRATION,
  UPDATE_REGISTRATION,
  INIT_REGISTRATION,
  SET_ACTIVE_REGISTRATION,
  SEARCH_AGENCIES,
  CREATE_PROFILE,
  CREATE_AOS_PROFILE,
  CREATE_AGENCY_PROFILE,
  CREATE_ARTIST_PROFILE,
  UPDATE_PROFILE,
  PROFILE_ACCESSES,
  CREATE_COMPANY,
  CREATE_AGENCY,
  SET_REGISTRATION_PROFILE,
  INIT_REGISTRATION_CONTACT,
  CHOOSE_PROFILE_TYPE,
  UPDATE_USER_INFO,
  CREATE_GIFT_ACCOUNT,
  UPDATE_GIFT_PROFILE,
} from './constants';

export const getRegistrationsAction = createRoutine(GET_STORED_REGISTRATIONS);
export const setActiveRegistrationsAction = createRoutine(SET_ACTIVE_REGISTRATION);
export const setRegistrationProfileAction = createRoutine(SET_REGISTRATION_PROFILE);
export const createRegistrationAction = createRoutine(CREATE_REGISTRATION);
export const initRegistrationAction = createRoutine(INIT_REGISTRATION);
export const updateRegistrationAction = createRoutine(UPDATE_REGISTRATION);
export const searchAgenciesAction = createRoutine(SEARCH_AGENCIES);
export const createProfileAction = createRoutine(CREATE_PROFILE);
export const createAosProfileAction = createRoutine(CREATE_AOS_PROFILE);
export const createAgencyProfileAction = createRoutine(CREATE_AGENCY_PROFILE);
export const createArtistProfileAction = createRoutine(CREATE_ARTIST_PROFILE);
export const setProfileAccessesAction = createRoutine(PROFILE_ACCESSES);
export const updateProfileAction = createRoutine(UPDATE_PROFILE);
export const createCompanyAction = createRoutine(CREATE_COMPANY);
export const createAgencyAction = createRoutine(CREATE_AGENCY);
export const initRegistrationContactAction = createRoutine(INIT_REGISTRATION_CONTACT);
export const chooseProfileTypeAction = createRoutine(CHOOSE_PROFILE_TYPE);
export const updateUserInfoAction = createRoutine(UPDATE_USER_INFO);
export const createGiftAccountAction = createRoutine(CREATE_GIFT_ACCOUNT);
export const updateGiftProfileAction = createRoutine(UPDATE_GIFT_PROFILE);
